import { atom } from 'recoil'

type AtomType = {
	isLoggedIn: boolean
	no: string
	username: string
	profileImg: string
	brandName: string
	role: string
	description: string
}
const vendorAtom = atom<AtomType>({
	key: 'vendor',
	default: {
		isLoggedIn: false,
		no: '',
		username: '',
		profileImg: '',
		brandName: '',
		role: '',
		description: '',
	},
})

export type VendorAtomType = AtomType
export default vendorAtom
